import {
  mergeOvernightSlots,
  Schedule,
  TimeString,
  TimeSlot,
  splitOvernightSlots,
} from "@loman/utils";
import { IAgentHours, ITimeSlot } from "../../types/hours";

export function convertHoursToBackend(
  hours: IAgentHours | null,
): IAgentHours | null {
  // for now just convert to the utils schedule type, todo: use the utils types directly
  const normalized = splitOvernightSlots(convertIAgentHoursToSchedule(hours));
  return convertScheduleToIAgentHours(normalized);
}

export function convertHoursToFrontend(
  hours: IAgentHours | null,
): IAgentHours | null {
  const normalized = mergeOvernightSlots(convertIAgentHoursToSchedule(hours));
  return convertScheduleToIAgentHours(normalized);
}

export function convertIAgentHoursToSchedule(
  hours: IAgentHours | null,
): Schedule | null {
  if (!hours) return null;
  return Object.entries(hours).reduce((acc, [day]) => {
    acc[day] = (hours[day] || []).map(
      (slot) =>
        ({
          open: slot.open as TimeString,
          close: slot.close as TimeString,
        }) as TimeSlot,
    );
    return acc;
  }, {} as Schedule);
}

export function convertScheduleToIAgentHours(
  schedule: Schedule | null,
): IAgentHours | null {
  if (!schedule) return null;
  const days: (keyof IAgentHours)[] = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  return days.reduce((acc, day) => {
    acc[day] = (schedule[day] || []).map(
      (slot) =>
        ({
          open: slot.open,
          close: slot.close,
        }) as ITimeSlot,
    );
    return acc;
  }, {} as IAgentHours);
}
